import React, { useEffect, useState } from "react";
import { showMultipleToasts } from "../../utils/apiSetup";
import { useTranslation } from "react-i18next";
import { getGlobalConfiguration } from "../../utils/getGlobalConfiguration";
import { isCustomEvent } from "../guards";

interface DocumentsProps {
  partyId: string;
  sipasUuid?: string;
  opportunityId?: string;
  searchMode: string;
  config: object;
  featureFlag: object;
}

export const Documents = ({ partyId, sipasUuid, opportunityId, searchMode, config, featureFlag }: DocumentsProps) => {
  const { t } = useTranslation();
  const [eventListenerRef, setEventListenerRef] = useState<HTMLElement | null>(null);

  const documentTranslations = t("portal:widgets.documentList", {
    returnObjects: true,
    interpolation: { skipOnVariables: true },
  });

  const styles = JSON.stringify({
    components: {
      WidgetCard: {
        title: {
          fontWeight: 700,
        },
        newButtonBackgroundColor: "#007A84",
        newButtonBackgroundColorHover: "#045B62 !important",
      },
    },
  });

  useEffect(() => {
    const handleOnSuccessAction = (event: Event) => {
      if (!isCustomEvent<{ messages?: string[]; action?: string }>(event)) return;

      const { messages, action } = event.detail;
      if (action === "fetch-documents") {
        return;
      }

      if (messages) {
        showMultipleToasts(messages);
      }
    };
    const handleReturnErrors = (event: Event) => {
      if (!isCustomEvent<{ errors?: string[] }>(event)) return;

      const { errors } = event.detail;

      if (errors) {
        showMultipleToasts(errors);
      }
    };

    const handleReturnMessages = (event: Event) => {
      if (!isCustomEvent<{ messages?: string[] }>(event)) return;

      const { messages } = event.detail;

      if (messages) {
        showMultipleToasts(messages);
      }
    };

    if (eventListenerRef) {
      eventListenerRef.addEventListener("success-widget-action", handleOnSuccessAction);
      eventListenerRef.addEventListener("widget-message", handleReturnMessages);
      eventListenerRef.addEventListener("widget-error", handleReturnErrors);
    }

    return () => {
      if (eventListenerRef) {
        eventListenerRef.removeEventListener("success-widget-action", handleOnSuccessAction);
        eventListenerRef.removeEventListener("widget-message", handleReturnMessages);
        eventListenerRef.removeEventListener("widget-error", handleReturnErrors);
      }
    };
  }, [eventListenerRef, sipasUuid, partyId, opportunityId]);

  const getFieldsConfiguration = () => {
    if (sipasUuid) {
      return getGlobalConfiguration("documentsWidget.policySectionDisplayColumns");
    }

    if (opportunityId) {
      return getGlobalConfiguration("documentsWidget.basketDisplayColumns");
    }

    return getGlobalConfiguration("documentsWidget.customerSectionDisplayColumns");
  };

  return (
    <ds-portfolio-document-widget
      ref={setEventListenerRef}
      variant="document"
      sipasuuid={sipasUuid}
      partyid={partyId}
      opportunityid={opportunityId}
      searchmode={searchMode}
      config={JSON.stringify(config)}
      styleoverrides={styles}
      featureflags={JSON.stringify({ document: featureFlag })}
      translations={JSON.stringify({ documentList: documentTranslations })}
      columnconfiguration={JSON.stringify(getFieldsConfiguration())}
    />
  );
};
